import { Button } from '../../components/Button';
import { ItemCard } from '../../components/ItemCard';
import { TextButton } from '../../components/TextButton';
import { CardWrapper, QuantityText, SelectedInfo } from './ExtrasCard.styles';
import type { ExtrasCardProps } from './ExtrasCard.types';

export function ExtrasCard({
  image,
  imageAspectRatio,
  imageMobileAspectRatio,
  title,
  description,
  variant = 'default',
  price,
  selected = false,
  quantity,
  onAdd,
  onRemove,
  onEditSelections,
  labels = {},
}: ExtrasCardProps) {
  const {
    add = 'Add',
    remove = 'Remove',
    quantity: quantityLabel = 'Quantity',
    editSelections = 'Edit selections',
    noImage = 'No image',
  } = labels;

  const stacked = variant === 'stacked';

  const customAction = (
    <Button
      type="button"
      variant={selected ? 'outline' : 'primary'}
      fullWidth={stacked || undefined}
      onClick={selected ? onRemove : onAdd}
    >
      {selected ? remove : add}
    </Button>
  );

  const selectedInfo =
    selected && (quantity || onEditSelections) ? (
      <SelectedInfo>
        {!!quantity && <QuantityText>{`${quantityLabel} ${quantity}`}</QuantityText>}
        {onEditSelections && (
          <TextButton size="base" onClick={onEditSelections}>
            {editSelections}
          </TextButton>
        )}
      </SelectedInfo>
    ) : undefined;

  const meta =
    description && selectedInfo ? (
      <SelectedInfo>
        {description}
        {selectedInfo}
      </SelectedInfo>
    ) : (
      description || selectedInfo
    );

  return (
    <CardWrapper>
      <ItemCard
        variant={stacked ? 'stacked' : undefined}
        image={{ ...image, placeholderLabel: image.placeholderLabel ?? noImage }}
        imageAspectRatio={imageAspectRatio}
        imageMobileAspectRatio={imageMobileAspectRatio}
        title={title}
        price={price}
        customAction={customAction}
        meta={meta}
      />
    </CardWrapper>
  );
}
